import "./masajesTerapeuticos.css";
import Tarjeta from "../Tarjeta/Tarjeta";
import { useServiciosCombinados } from "../../hook/useServiciosCombinados";
import FadeInSection from "../FadeInSection/FadeInSection";
import { useConvertor } from "../../hook/useConversor";
import { useMoneda } from "../../context/MonedaContext";

const MasajesTerapeuticos = () => {
  const { combinados, cargando, error } = useServiciosCombinados();
  const {moneda} = useMoneda();
  const {preciosConvertidos} = useConvertor(combinados,moneda)

  if (cargando) return <p className="cargando">Cargando...</p>;
  if (error) return <p className="error">Error: {error}</p>;

  // Filtrar los que sean de tipo Masaje
  const masajes = combinados.slice(0, 7);

  return (
    <section className="jbSeccionTemporal">
      <h1 className="jbTituloMT">Masajes Ayurvédicos</h1>
      <FadeInSection>
        <div className="jbContenedorTarjetas">
          {masajes.map((servicio) => (
            <Tarjeta key={servicio.id} servicio={{
              ...servicio,
              precioConvertido: preciosConvertidos[servicio.id]
            }} 
            moneda = {moneda}
            />
          ))}
        </div>
      </FadeInSection>
    </section>
  );
};

export default MasajesTerapeuticos;
